import ImageSlider from "./common/ImageSlider";
import ProjectInfo from "./project-details/ProjectInfo";
import ProjectDescription from "./project-details/ProjectDescription";
import Footer from "./Footer";
import Header from "./Header";

const Imo241 = () => {
  const images = [
    "assets/img/portfolio/imo241.png",
    "assets/img/portfolio/imo241-1.png",
    "assets/img/portfolio/imo241-2.png",
    "assets/img/portfolio/imo241-3.png",
    "assets/img/portfolio/imo241-4.png",
  ];
  const projectData = {
    title: "Imo241",
    stack: "Wordpress",
    projectUrl: "https://imo241.com",
    description: "imo241Desc",
  };

  return (
    <>
      <Header />
      <main id="main">
        <section className="portfolio-details">
          <div className="container">
            <div className="row gy-4">
              <ImageSlider images={images} />

              <div className="col-lg-4">
                <ProjectInfo
                  stack={projectData.stack}
                  projectUrl={projectData.projectUrl}
                />
                <ProjectDescription descriptionKey={projectData.description} />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Imo241;
